import { mount } from 'svelte'
import './app.css'
import App from './App.svelte'
import { initializeSupportView } from './lib/supportView'

initializeSupportView()

const app = mount(App, {
  target: document.getElementById('app')!,
})

export default app
